import { useState, useRef } from 'react'
import { formatDuration } from '../../utils/videoMetadata'

function VideoPreview({ videoUrl, metadata }) {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)

  const togglePlayPause = () => {
    if (!videoRef.current) return

    if (isPlaying) {
      videoRef.current.pause()
      setIsPlaying(false)
    } else {
      videoRef.current.play()
      setIsPlaying(true)
    }
  }

  const handleVideoEnd = () => {
    setIsPlaying(false)
  }

  return (
    <div className="relative aspect-[9/16] bg-gray-100 rounded-lg overflow-hidden max-w-xs mx-auto">
      <video
        ref={videoRef}
        src={videoUrl}
        className="w-full h-full object-cover"
        onClick={togglePlayPause}
        onEnded={handleVideoEnd}
        playsInline
        preload="metadata"
      />

      {/* Play/Pause Overlay */}
      {!isPlaying && (
        <div
          className="absolute inset-0 flex items-center justify-center cursor-pointer"
          onClick={togglePlayPause}
        >
          <div className="bg-black bg-opacity-50 rounded-full p-4 hover:bg-opacity-70 transition-all">
            <svg
              className="h-8 w-8 text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      )}

      {/* Metadata Badges */}
      {metadata && (
        <div className="absolute bottom-2 left-2 right-2 flex justify-between">
          {metadata.duration && (
            <span className="bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
              {formatDuration(metadata.duration)}
            </span>
          )}
          {metadata.resolution && (
            <span className="bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
              {metadata.resolution}
            </span>
          )}
        </div>
      )}

      {/* Audio Indicator */}
      {metadata?.hasAudio && (
        <div className="absolute top-2 right-2">
          <span className="bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded inline-flex items-center">
            <svg className="h-3 w-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
              />
            </svg>
            Audio
          </span>
        </div>
      )}
    </div>
  )
}

export default VideoPreview
